import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import KeyValue from "../types/keyValue";
import FilterSet from "../types/filterSet";

interface FilterSetState {
  filterSets: KeyValue[];
  status: "idle" | "loading" | "failed";
}

const initialState: FilterSetState = {
  filterSets: [],
  status: "idle",
};

export const postFilterSet = createAsyncThunk<FilterSet, FilterSet>(
  "filter-set/post",
  async (model: FilterSet) => {
    const response = await http.post<FilterSet>(`filter-set`, model, {
      params: {
        successToast: true,
      },
    });
    return response.data;
  }
);

export const getFilterSet = createAsyncThunk<FilterSet, number>(
  "filter-set/get/id",
  async (id: number) => {
    const response = await http.get<FilterSet>(`filter-set/${id}`);
    return response.data;
  }
);

export const getFilterSets = createAsyncThunk<KeyValue[]>(
  "filter-set/get",
  async () => {
    const response = await http.get<KeyValue[]>(`filter-set`);
    return response.data;
  }
);

export const deleteFilterSet = createAsyncThunk<null, number>(
  "filter-set/delete",
  async (id: number) => {
    const response = await http.delete(`filter-set/${id}`, {
      params: {
        successToast: true,
      },
    });
    return response.data;
  }
);

const filterSetSlice = createSlice({
  name: "filterSet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postFilterSet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postFilterSet.fulfilled, (state, action) => {
        state.status = "idle";
      })
      .addCase(postFilterSet.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getFilterSet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFilterSet.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(getFilterSet.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getFilterSets.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFilterSets.fulfilled, (state, action) => {
        state.status = "idle";
        state.filterSets = action.payload;
      })
      .addCase(getFilterSets.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(deleteFilterSet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteFilterSet.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteFilterSet.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default filterSetSlice.reducer;
